export default "__VITE_ASSET__$pEirWUJ__"